var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 12L14 7L9 2","strokeWidth":"2","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M14 7L0 7","strokeWidth":"2","key":1})]);
}

ArrowRight.defaultProps = {"width":"13","height":"11","viewBox":"0 0 16 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
